<template>
	<select @change='change' v-model="selected" class='form-control my-control table-control'>
		<option v-for="option in options" :value='option.id'>
			{{ option.name }}
		</option>
	</select>
</template>

<script>
	import {DB} from './../../../constants'
	const OZU = 'get_ozu.php'

	import {EventBus} from '../../../lib/EventBus'

	export default {
		name: 'protectiveCatExt',
		data: function () { 
			return {
				selected: '',
				options: []
			}
		},
		props: {
			line_count: 0,
			type: '',
			id: null
		},
		watch: {
			id(val) {
				if(val) {
					this.selected = val
				}
			}
		},
		methods: {
			change () {
				EventBus.$emit(`${this.type}_protective_cat_ext`, {index: this.line_count, value: this.selected})
			},
			fill () {
				fetch(DB + OZU, {
					credentials: 'include'
				})
				.then(data => data.json())
				.then(data => {
					if (data) {
						this.options = data
						this.selected = this.id ? this.id : data[0].id
					}
					else {
						this.options = []
						this.selected = null
					}
					this.change()
				})
				.catch(err => console.log(err))
			}
		},
		created: function () {
			//EventBus.$on(`${this.type}_protective_cat_${this.line_count}`, id => {
			//	this.fill(id)
			//})

			this.fill()
		},
		beforeDestroy () {
			//EventBus.$off(`${this.type}_protective_cat_${this.line_count}`)
		}
	}
</script>


// WEBPACK FOOTER //
// protectiveCatExt.vue?a0d4b6f2